import React from 'react'

export function TextError({ children }) {
  return (
    <div className="text-danger">
      {children}
    </div>
  )
}

export default TextError